import { render, staticRenderFns } from "./ProcessCompleteConventional.vue?vue&type=template&id=06120a04&"
import script from "./ProcessCompleteConventional.vue?vue&type=script&lang=js&"
export * from "./ProcessCompleteConventional.vue?vue&type=script&lang=js&"
import style0 from "./ProcessCompleteConventional.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports